export default [
    {
        path: "/selectUnit",
        name: "selectUnit",
        component: () => import("./index"),
        meta: {
            title: "切换单位"
        }
    },
]